/**
 * Shared Logo component for consistent branding across the application
 * @param {Object} props - Component props
 * @param {string} [props.size='md'] - Size variant (sm, md, lg, xl)
 * @param {string} [props.className] - Additional CSS classes
 */
import React from 'react'
import PropTypes from 'prop-types'

const sizes = {
  sm: 'h-6',
  md: 'h-8',
  lg: 'h-12',
  xl: 'h-16'
}

function Logo({ size = 'md', className = '' }) {
  return (
    <img
      src={`/photowhim_logo_${size}.png`}
      alt="PhotoWhim"
      className={`${sizes[size]} w-auto ${className}`}
    />
  )
}

Logo.propTypes = {
  size: PropTypes.oneOf(['sm', 'md', 'lg', 'xl']),
  className: PropTypes.string
}

export default Logo 